<script>
    import { getContext } from 'svelte';

    // --- Properties
    export let dataKey;
    const {
        orderCC: order,
        activeCC: active,
        creditcards,
        hoverCC,
        unhoverCC,
        toggleCCselection,
    } = getContext(dataKey);
</script>

<div id="creditcards">
    <div class="header">
        <span>Creditcards</span>
    </div>
    <div class="labels">
        <span class="num">ccnum</span>
        <span class="tr">#</span>
        <span class="pr">Kr</span>
    </div>
    {#each $order as ccnum}
        {#if ccnum in $creditcards}
            <div
                class="cc"
                class:fade={!$active[ccnum]}
                on:mouseenter={() => hoverCC($creditcards[ccnum])}
                on:mouseleave={() => unhoverCC($creditcards[ccnum])}
                on:click={() => toggleCCselection($creditcards[ccnum])}
            >
                <span class="num">{ccnum} </span>
                <span class="tr">{$creditcards[ccnum].n_transactions}</span>
                <span class="pr">{$creditcards[ccnum].t_price.toFixed(2)}</span>
            </div>
        {/if}
    {/each}
</div>

<style>
    #creditcards {
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        flex-direction: column;
        margin-left: 25px;
        margin-right: 125px;
    }

    #creditcards div {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .header {
        height: 20px;
    }

    .header span {
        line-height: 20px;
        display: block;
        width: 135px;
        text-align: center;
    }

    .labels {
        height: 40px;
        font-size: 15px;
    }

    .labels span {
        display: block;
        text-align: right;
        line-height: 15px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .cc {
        height: 10px;
        font-size: 12px;
        text-align: right;
        cursor: pointer;
    }

    .cc.fade {
        opacity: 0.5;
    }

    .cc * {
        display: block;
        line-height: 10px;
        text-align: right;
    }

    .num {
        width: 30px;
    }

    .tr {
        width: 35px;
    }

    .pr {
        width: 70px;
    }
</style>
